export enum AuditObjectTypeEnum {
  CAROUSEL = 'CAROUSEL',
  EQUALIZE = 'EQUALIZE',
  BLACKLIST = 'BLACKLIST',
  PRODUCTS_RANKING = 'PRODUCTS',
  ATTRIBUTES_RANKING = 'ATTRIBUTES',
  PROMOTION = 'PROMOTION',
  REDIRECTION = 'REDIRECTION',
  SYNONYM = 'SYNONYM',
  BROWSE_CONFIGURATION = 'BROWSE_CONFIGURATION',
  SEARCH_CONFIGURATION = 'SEARCH_CONFIGURATION',
  RELATED_TAGS = 'RELATED_TAGS',
  NEXT_QUERIES = 'NEXT_QUERIES',
  EXPLAIN = 'EXPLAIN',
  CLIENT_CONFIG = 'CLIENT_CONFIG',
  ENDPOINT_CONFIG = 'ENDPOINT_CONFIG',
  FEATURE_CONFIG = 'FEATURE_CONFIG',
  INDEX_CLIENT = 'INDEX_CLIENT',
  INDEX_FEED_CONFIGURATION = 'INDEX_FEED_CONFIGURATION',
  INDEX_SCHEMA_CONFIGURATION = 'INDEX_SCHEMA_CONFIGURATION',
}
